import axios from '@/utils/request'
import { AxiosPromise } from 'axios'
import { BaseResponse, ResponseStatus } from '.'

export { BaseResponse, ResponseStatus }

export interface CompleteDepositRequest {
  walletTransactionId: string
}

export interface GetTransactionStatusResponse {
  status: 'Pending' | 'Success' | 'Failure'
  state: string
  relatedState: string
}

export interface MemberPaymentTransactionPaginatedEntity {
  items: MemberPaymentTransaction[]
  hasMorePage: boolean
  pageCount: number
  itemCount: number
}

export enum TransactionState {
  Created = 'Created',
  Pending = 'Pending',
  Approved = 'Approved',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
  RefundPending = 'RefundPending',
  Refunded = 'Refunded'
}
export interface MemberPaymentTransaction {
  transactionId: string
  amount: MoneyEntity
  remark: string | null
  state: TransactionState
  type: 'deposit' | 'withdraw' | 'entryfee'
  createTime: number
}

export interface MoneyEntity {
  currency: string
  amount: string
}

const API_PREFIX = '/payment/v1'

export class PaymentAPI {
  public static completeDeposit(
    walletTransactionId: string
  ): AxiosPromise<BaseResponse> {
    return axios.post(`${API_PREFIX}/deposit/complete`, {
      walletTransactionId
    })
  }

  public static cancelDeposit(
    walletTransactionId: string
  ): AxiosPromise<BaseResponse> {
    return axios.post(`${API_PREFIX}/deposit/cancel`, {
      walletTransactionId
    })
  }

  public static getTransactionStatus(
    walletTransactionId: string
  ): AxiosPromise<BaseResponse<GetTransactionStatusResponse>> {
    return axios.get(`${API_PREFIX}/transactions/${walletTransactionId}/status`)
  }

  public static getMemberPaymentTransaction(
    page: number = 1
  ): AxiosPromise<BaseResponse<MemberPaymentTransactionPaginatedEntity>> {
    return axios.get(`${API_PREFIX}/transactions`, {
      params: {
        page: page
      }
    })
  }
}
